import React, { FC } from 'react'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import { Col, Form, Row } from 'antd'
import { useTranslation } from 'react-i18next'
import { debounce } from 'lodash'
import { useSelector } from 'react-redux'
import { RootState } from '../../reducers'

// atoms
import SelectField from '../../atoms/SelectField'

// interfaces
import { IForm } from '../../types/interfaces'

// utils
import { FORM } from '../../utils/enums'

export type ComponentProps = {
	disable: boolean
	inputName: string
	outputBeforeName: string
	outputAfterName: string
}

type Props = InjectedFormProps<IForm, ComponentProps> & ComponentProps

const ProceduresSettingsForm: FC<Props> = (props) => {
	const { t } = useTranslation()
	const { handleSubmit, disable, inputName, outputBeforeName, outputAfterName } = props
	const procedures = useSelector((state: RootState) => state.formTemplate.procedures)
	return (
		<Form layout={'vertical'} className={''} onSubmitCapture={handleSubmit}>
			<Row justify={'center'} className={'w-full mt-2'}>
				<Col span={24}>
					<Field
						component={SelectField}
						label={t('loc:Entry stored procedure')}
						name={inputName}
						loading={procedures?.isLoading}
						options={procedures?.data}
						size={'large'}
						disabled={disable}
						clearBtn={true}
					/>
				</Col>
				<Col span={24}>
					<Field
						component={SelectField}
						label={t('loc:Output stored procedure - befor data save')}
						name={outputBeforeName}
						loading={procedures?.isLoading}
						options={procedures?.data}
						size={'large'}
						disabled={disable}
						clearBtn={true}
					/>
				</Col>
				<Col span={24}>
					<Field
						component={SelectField}
						label={t('loc:Output stored procedure - after data save')}
						name={outputAfterName}
						loading={procedures?.isLoading}
						options={procedures?.data}
						size={'large'}
						disabled={disable}
						clearBtn={true}
					/>
				</Col>
			</Row>
		</Form>
	)
}

const form = reduxForm<IForm, ComponentProps>({
	form: FORM.PROCEDURES_SETTINGS,
	forceUnregisterOnUnmount: true,
	touchOnChange: true,
	destroyOnUnmount: true,
	onChange: debounce((values, dispatch, props) => {
		if (props.anyTouched) {
			props.submit()
		}
	}, 600)
})(ProceduresSettingsForm)

export default form
